//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import axios from "axios";


export default {

    props: {
        /*
        * Profile - only used for localstorage key
        */
        profile: {
            type: String,
            required: true,
        },
        /*
        * Youtube access token.
        */
        token: {
            type: String,
            required: true,
        },
        /*
        * Youtube Playlist.
        */
        playlist: {
            type: String,
            default: '',
            required: false,
        },
        /*
        * Number of items per load.
        */
        count: {
            type: Number,
            default: 3,
            required: false,
        },
        /*
        * To Display the Load more button
        */
        displayLoadMore: {
            type: Boolean,
            default: true,
            required: false,
        },
        /*
        * To Display the title
        */
        displayTitle: {
            type: Boolean,
            default: false,
            required: false,
        },
        /*
        * To Display the description
        */
        displayDescription: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    data: () => ({
        feed: [],
        /*
        *  Number of feed load.
        */
        pageLoads: 1,
        fromCache: false,
        nextMaxId: '', // todo youtube
        moreData: true,
    }),

    methods: {
        getUserFeed () {
            /* First check localstorage for data */

            var cachedTime = localStorage.getItem('youtubetime_'+ this.profile+this.playlist);

            let expiryInMinutes = 15; // 15 mins

            let fetchNewData = true;
            
            if (cachedTime !== undefined && cachedTime !== null && parseInt(cachedTime)+(expiryInMinutes * 60 * 1000) > new Date().getTime()) {

                console.log("yt now = ");
                console.log( new Date().getTime());
                console.warn("yt use cached version");
                console.log('yt cached time='+cachedTime);
                console.log(` yt cachedTime+(1 * 60 * 1000) ${parseInt(cachedTime)+(60 * 60 * 1000)}   > now`);

                console.log(`yt minutess time since last ${(parseInt(cachedTime)-  new Date().getTime() ) / 1000/60 }  `);

                var cachedYoutube = localStorage.getItem('youtube_'+ this.profile+this.playlist);
               
                if (cachedYoutube !== undefined && cachedYoutube !== null){
                    let cache =  JSON.parse(cachedYoutube);
                    this.feed = cache.feed;
                    //this.nextMaxId =  cache.nextMaxId;
                    fetchNewData = false;
                    this.fromCache = true;
                }

            } 

            if(fetchNewData) { // Expired or localstorage data doesn't exist
                console.log(`yt minutess time since last ${(parseInt(cachedTime)-  new Date().getTime() ) / 1000/60 }  `);

                console.warn("yt EXPIRED or DATAT DOESNT EXIST");


                let _this = this;

                axios
                .get(pageInfo.ajax_url, {
                    params: {
                        action: 'get_youtube_feed',
                        playlist: this.playlist
                    },
                })
                .then(function(response) {

                    console.log(response);

                    _this.feed.push(...response.data.data);

                    // if(response.data.pagination.next_max_id !== undefined)
                    //     _this.nextMaxId = response.data.pagination.next_max_id;
                    // else
                    //     _this.moreData = false;

                    localStorage.setItem('youtube_'+ _this.profile+_this.playlist, JSON.stringify({ 'feed': _this.feed, 'nextMaxId': _this.nextMaxId}));
                    localStorage.setItem('youtubetime_'+ _this.profile+_this.playlist, new Date().getTime());
   
                })
                .catch(function(error) {
                    console.error(error);

                    /* just get whatever we have in localstorage if available */
                    console.log("yt Cannot get data from db: will try to retrieve from cache");
                    var cachedYoutube = localStorage.getItem('youtube_'+_this.profile+_this.playlist);
               
                    if (cachedYoutube !== undefined && cachedYoutube !== null) {
                        let cache =  JSON.parse(cachedYoutube);
                        this.feed = cache.feed;
                        this.nextMaxId =  cache.nextMaxId;
                    }

                });

            }

            
        },
        fetchFeed () {
 
            console.log(`yt fetching data from db`);

            let _this = this;

            axios
            .get(pageInfo.ajax_url, {
                params: {
                    action: 'get_youtube_feed',
                    playlist: this.playlist
                },
            })
            .then(function(response) {

                _this.feed.push(...response.data.data);
 
                // if(response.data.pagination.next_max_id !== undefined)
                //     _this.nextMaxId = response.data.pagination.next_max_id;
                // else
                //     _this.moreData = false;

                localStorage.setItem('youtube_'+ _this.profile+_this.playlist, JSON.stringify({ 'feed': _this.feed, 'nextMaxId': _this.nextMaxId }));
                localStorage.setItem('youtubetime_'+ _this.profile+_this.playlist, new Date().getTime());

            })
            .catch(function(error) {
                console.error(error);
            });
            
        },
        loadMore() {
            this.pageLoads ++; // incrementing this will automatically show any extras already in cache
            console.log("yt click load more."+this.pageLoads+" count=" + this.count + " feed length = "+this.feed.length);
            // otherwise if no extra ones in cache or we did not originally get from cache fetch more

            // if(!this.fromCache || this.feed.length < this.pageLoads * this.count ) {
            if(this.feed.length < this.pageLoads * this.count ) {
                //this.fetchFeed(); //  todo - currently we are not fetching any more from youtube, just displaying the items from plugin ajax call
                this.moreData = false; // therefore hide load more button
                console.warn("no more items");
            }
        }, 
        imageStyle(img) {
            if (!img) return;
            return {
                'background-image': `url(${img})`,
            };
        },
        itemClass(type) {
            return "youtube-feed__item--"+type;
        },
            
    },
 
    created: function() {
        this.getUserFeed();
    },
    
    filters: {
        truncate: function (text, length, suffix = '&hellip;') {
            text = text.replace('[&hellip;]',''); // remove any ellipses added by wp excerpt

            let truncatedText = text.substring(0, length);
            if (truncatedText == text)
                return text
            else
                return truncatedText + suffix;
        },
    },  
}



// WEBPACK FOOTER //
// ./scripts/vue/YoutubeFeed.vue